import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Home",
    redirect: { name: "LiveDashboard" },
  },
  {
    path: "/packages",
    name: "PackageList",
    component: () => import('./views/package/PackageList.vue'),
  },
  {
    path: "/import-packages",
    name: "ImportPackageList",
    component: () => import('./views/package/PackageImportFile.vue'),
  },
  {
    path: "/packages-waiting-cod",
    name: "PackageWaitingCod",
    component: () => import('./views/package/PackageWaitingCod.vue'),
  },
  {
    path: "/packages-bank-deposit",
    name: "PackageBankDeposit",
    component: () => import('./views/package/PackageBankDeposit.vue'),
  },
  {
    path: "/packages/create",
    name: "Create Package",
    component: () => import('./views/package/CreatePackageForm.vue'),
  },
  {
    path: "/packages/edit/:id",
    name: "Edit Package",
    component: () => import('./views/package/EditPackageForm.vue'),
  },
  {
    path: "/packages/:id/awb",
    name: "AWB",
    component: () => import('./views/package/AWB.vue'),
    meta: { layout: "empty" }
  },
  {
    path: "/live-dashboard",
    name: "LiveDashboard",
    component: () => import('./views/dashboard/LiveDashboard.vue'),
  },
  {
    path: "/stores",
    name: "StoresList",
    component: () => import('./views/stores/StoresList.vue'),
  },
  {
    path: "/cod",
    name: "COD",
    component: () => import('./views/cod/COD.vue'),
  },
  {
    path: "/cod/delivered/:id",
    name: "CODDetail",
    component: () => import('./views/cod/DeliveryCodDetail.vue'),
  },
  {
    path: "/cod/lost/:id",
    name: "LostDetail",
    component: () => import('./views/cod/LostCodDetail.vue'),
  },
  {
    path: "/support",
    name: "Support",
    component: () => import('./views/support/SupportList.vue'),
  },
  {
    path: "/support/:id",
    name: "SupportDetail",
    component: () => import('./views/support/SupportDetail.vue'),
  },
  {
    path: "/user/profile",
    name: "UserProfile",
    component: () => import('./views/users/UserProfile.vue'),
  },
  {
    path: "/packages/upload-excel",
    name: "UploadExcel",
    component: () => import('./views/excelv2/index.vue'),
  },
  {
    path: "/packages/edit-created/:code&:type",
    name: "EditCreatedPackage",
    component: () => import('./views/excelv2/EditCreatedPackage.vue'),
  },
  {
    path: "/packages/review/:param",
    name: "ReviewExcel",
    component: () => import('./views/excelv2/review.vue'),
  },
  {
    path: "/packages/edit/id=:id&no=:numb&type=:type",
    name: "EditRecordExcel",
    component: () => import('./views/excelv2/detail.vue'),
  },
  {
    path: "/packages/copy/:id",
    name: "PackageCopy",
    component: () => import('./views/package/CreatePackageForm.vue'),
  },
  {
    path: "/packages/:id",
    name: "PackageDetail",
    component: () => import('./views/package/PackageDetail.vue'),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import('./views/Login.vue'),
    meta: { layout: "empty" }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import('./views/Register.vue'),
    meta: { layout: "empty" }
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () => import('./views/ForgotPassword.vue'),
    meta: { layout: "empty" }
  },
  {
    path: "/confirm-password/:id",
    name: "Confirm Password",
    component: () => import('./views/ConfirmPassword.vue'),
    meta: { layout: "empty" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === '/register' || to.name === 'Confirm Password') {
    next();
    return;
  }
  if (to.path === '/forgot-password' || to.name === 'Forgot Password') {
    next();
    return;
  }

  const token = localStorage.getItem('access_token');
  if (to.path !== '/login' && !token) {
    next('/login');
    return;
  }

  next();
});

export default router;
